module.exports = __webpack_public_path__ + "media/components/resources/svgs/ic_download-67838ad3b307b704d7404a786f67cf7f.svg";